import { useEffect, useState } from 'react';
import CheckboxContainer from '../../../components/SegmentFilters/checkboxContainer';
import moment from 'moment';

const Filters  = [
    {
        name: 'Platform',
        value: 'platform',
        type: 'list',
    },
    {
        name: 'Browser',
        value: 'browser',
        type: 'list',
    },
    {
        name: 'Geo Location',
        value: 'country_iso',
        type: 'list',
    },
    {
        name: 'Subscription Date',
        value: 'first-seen',
        type: 'date',
    },
    {
        name: 'Last Website Visit',
        value: 'last-seen',
        type: 'date',
    },
    {
        name: 'URLs Visited',
        value: 'url-visited',
        type: 'list',
    }
];

const listOperators = ['equal', 'not equal'];

const dateOperators = [
    'before',
    'after',
    'on',
    'between'
];

const CreateSeg = ({
    segment, 
    deleSegmentFilter, 
    index = 0, 
    segments, 
    updateFilter,
    platforms,
    browsers,
    countries,
    visitedWebsites
}) => {

    const [pivots, setPivots] = useState([]);

    const [filterPivot, setFilterPivot] = useState({});
    

    const [operatorSelected, setOperatorSelected] = useState('');

    const [isFilterOpen , setIsFilterOpen] = useState(false);

    const [filterValue, setFilterValue] = useState([]);

    const [ valueString, setValueString ] = useState('');
    
    const [ dateError, setDateError ] = useState(null);

    useEffect(() => {
        const revisedFilters = Filters.filter(({value}) => {
            const filterIndex = segments.findIndex(({name}) => name === value);
            return filterIndex < 0
        })
        const defaultFilter = revisedFilters[0];
        setPivots(revisedFilters);
        const selectedPivot = revisedFilters.find(({value}) => value === segment.name) || revisedFilters[0];
        setFilterPivot(selectedPivot);
        setFilterValue(segment.values);
        getValueSelected(segment.values || []);
        setOperatorSelected(segment.operator);
        updateFilter({
            name: defaultFilter.value,
            operator: defaultFilter.type === 'list' ? listOperators[0]: dateOperators[0],
            values: [],
        }, index);
    }, []);

    useEffect(() => {
        const revisedFilters = Filters.filter(({value}) => {
            const filterIndex = segments.findIndex(({name}) => name === value);
            if(segment.name === value) {
                return true;
            }
            return filterIndex < 0
        })
        setPivots(revisedFilters);
        const selectedPivot = revisedFilters.find(({value}) => value === segment.name) || revisedFilters[0];
        setFilterPivot(selectedPivot);
        setFilterValue(segment.values);
        getValueSelected(segment.values || []);        
        setOperatorSelected(segment.operator);
    }, [segments]);

    const changeFilter = (pivotValue) => {
        const filter = Filters.find(({value}) => value === pivotValue);
        if(filter.type === 'list') {
            setOperatorSelected(listOperators[0]);
        } else {
            setOperatorSelected(dateOperators[0]);
        }
        setFilterPivot(filter);
        setFilterValue([]);
        getValueSelected([]);
        updateFilter({
            ...segment,
            name: pivotValue,
            operator: filter.type === 'list' ? listOperators[0] : dateOperators[0],
            values: [],
        }, index);
    }

    const operator = filterPivot.type === 'list' ? listOperators : dateOperators;

    const changeOperator = (operator) => {
        setOperatorSelected(operator);
        updateFilter({
            ...segment,
            operator,
        }, index)
    }

    const getValues = () => {
        if(filterPivot.value === 'platform') {
            return platforms;
        }
        if(filterPivot.value === 'browser') {
            return browsers;
        }
        if(filterPivot.value === 'country_iso') {
            return countries;
        }
        if(filterPivot.value === 'url-visited') {
            return visitedWebsites;
        }
    }

    const changeValue = (values) => {
        setFilterValue(values);
        getValueSelected(values);
        updateFilter({
            ...segment,
            values,
        }, index)
    }

    const getValueSelected = (values) => {
        const valueStr = values.length > 1 ? `${values[0]} & ${values.length - 1} more` : values[0];
        setValueString(valueStr || '');
    }

    const setDateFilterValue = (value, idx) => {
        const dateValues = [...segment.values];
            
        if(moment(value).isAfter(getMaxDate())) {
            dateValues[idx] = null;
            setDateError('Date should not be more than 15 years');
        } else if(moment(value).isBefore(getMinDate())) {
            dateValues[idx] = null;
            setDateError('Date should not be less than 15 years');
        } else {
            dateValues[idx] = value;
            setDateError(null);
        }
        updateFilter({
            ...segment,
            values: dateValues,
        }, index)
    }

    const getMaxDate = () => {
        return moment().add(15, 'years').format('YYYY-MM-DD');
    }

    const getMinDate = () => {
        return moment().subtract(15, 'years').format('YYYY-MM-DD');
    }

    return <div className="row">
        <div className="col-12 col-md-6 col-lg-3 col-xl-2 mb-3">
            <div className="custom-select">
                <select 
                    style={{textTransform : 'capitalize'}} 
                    className="form-control"  
                    value={filterPivot.value} 
                    onChange={({target}) => changeFilter(target.value)}
                >
                    {
                        pivots.map(({name, value}, index) => <option 
                            key={index} 
                            value={value} >{name}</option>)
                    }    
                </select>
            </div>
        </div>
        
        <div className="col-12 col-md-6 col-lg-3 col-xl-2">
            <div className="form-group">
                <div className="custom-select">
                    <select 
                        style={{textTransform : 'capitalize'}} 
                        className="form-control"  
                        value={operatorSelected} 
                        onChange={({target}) => changeOperator(target.value)}
                    >
                        {
                            operator.map((op, index) => <option 
                                key={index} 
                                value={op} >{op}</option>)
                        }    
                    </select>
                </div>
            </div>
        </div>
        
        <div className={filterPivot.value !== 'url-visited' ? 'col-12 col-md-6 col-lg-3 col-xl-2' : 'col-12 col-md-6 col-lg-4 col-xl-4'}>
            <div className="form-group date-form-group">
                {
                    filterPivot.type === 'list' && <>
                        <div className="input-addon input-group-right" onClick={() => setIsFilterOpen(!isFilterOpen)} >
                            <i className="icon icon-chevron-down icon-down"></i>
                            <input
                                value={valueString}
                                className="form-control"
                                readOnly
                                style={{textTransform: filterPivot.value !== 'url-visited' ? 'capitalize' : ''}}
                            />
                        </div>
                        {
                            isFilterOpen && <CheckboxContainer
                                setIsFilterOpen={setIsFilterOpen}
                                checkBoxData={getValues()}
                                filterValue={filterValue}
                                filter={filterPivot.value}
                                changeValue={changeValue}
                            />
                        }
                    </>
                }
                {
                    filterPivot.type === 'date' &&   <div className="form-group d-flex flex-column" style={{gap: '10px'}}>
                    <input type="date" 
                        min={getMinDate()}
                        placeholder="Website URL"  
                        className="form-control"
                        value={segment?.values ? segment?.values[0] : ''}
                        onChange={({target}) => setDateFilterValue(target.value, 0)}
                        max={getMaxDate()}
                    />
                    { dateError && <span className="error-message">{dateError}</span> }
                
                { operatorSelected === 'between' && <> <input 
                    min={segment?.values ? segment?.values[0] : getMinDate()}
                    disabled={!segment.values[0]}
                    type="date" 
                    placeholder="Website URL"  
                    className="form-control"
                    value={segment?.values ? segment?.values[1] : ''}
                    onChange={({target}) => setDateFilterValue(target.value, 1)}
                    max={getMaxDate()}
                    /> 
                    { (segment?.values[1] && dateError) && <span className="error-message">{dateError}</span> }   
                    </>
                }
                
            </div>
                }
            </div>
        </div>

        {
            index > 0 && <div className="col-12 col-md-6 col-lg-2 col-xl-2 mb-2">
                <button onClick={() => deleSegmentFilter(index)} className="btn btn-grey"><i className="icon icon-delete"></i></button>
            </div>
        } 

    </div>
}

export default CreateSeg;